import React from "react";
import Representation from './Representation';

const Modal = (props) => {
  return <Representation
    {...props}
  />
}

export default Modal;